import { computed, Directive, inject, input } from '@angular/core';
import { CalendarEvent, CalendarView } from 'angular-calendar';

import { CalendarHelper } from '../../helpers/calendar/calendar.helper';

@Directive({
  selector: '[libCalendarEventNeighbors]',
  host: {
    '[class.hidden]': 'hasNeighboringEvents()',
  },
})
export class CalendarEventNeighborsDirective {
  private readonly calendarHelper = inject(CalendarHelper);

  readonly event = input.required<CalendarEvent>();
  readonly events = input.required<CalendarEvent[]>();
  readonly calendarView = input.required<CalendarView>();
  readonly acceptableNeighbors = input<number>(1);

  protected readonly hasNeighboringEvents = computed(() => {
    const event = this.event();

    if (!event || this.events().length === 0 || ![CalendarView.Week, CalendarView.Day].includes(this.calendarView()) || this.acceptableNeighbors() < 1) {
      return false;
    }

    return this.calendarHelper.hasNeighboringEvents(
      event,
      this.events(),
      this.calendarView(),
      this.acceptableNeighbors()
    );
  });
}
